var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.isFormValid,
        callback: function($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "mb-12 pt-2 float-remover", attrs: { color: "white" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: "Sub-categoría",
                      "prepend-icon": "mdi-animation-outline",
                      "no-data-text": "No hay subcategorías disponibles",
                      items: _vm.formValues.typings.subCategories,
                      "return-object": "",
                      "item-text": "name",
                      rules: [_vm.rules.required()]
                    },
                    on: {
                      change: function() {
                        return (_vm.generalInformation.subject = null)
                      }
                    },
                    model: {
                      value: _vm.generalInformation.subCategory,
                      callback: function($$v) {
                        _vm.$set(_vm.generalInformation, "subCategory", $$v)
                      },
                      expression: "generalInformation.subCategory"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: "Asunto",
                      "prepend-icon": "mdi-account-question",
                      "no-data-text": "No hay asuntos disponibles",
                      disabled: !_vm.generalInformation.subCategory,
                      items: _vm.items,
                      "item-text": "name",
                      rules: [_vm.rules.required()],
                      "return-object": ""
                    },
                    model: {
                      value: _vm.generalInformation.subject,
                      callback: function($$v) {
                        _vm.$set(_vm.generalInformation, "subject", $$v)
                      },
                      expression: "generalInformation.subject"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "mr-2" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Nombre",
                              rules: [
                                _vm.rules.required(),
                                _vm.rules.fieldLength(50),
                                _vm.rules.specialCharacters(),
                                _vm.rules.allowLettersExclusively()
                              ],
                              disabled: "",
                              "prepend-icon": "mdi-account"
                            },
                            model: {
                              value: _vm.generalInformation.firstName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalInformation,
                                  "firstName",
                                  $$v
                                )
                              },
                              expression: "generalInformation.firstName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Apellido",
                              rules: [
                                _vm.rules.required(),
                                _vm.rules.fieldLength(50),
                                _vm.rules.specialCharacters(),
                                _vm.rules.allowLettersExclusively()
                              ],
                              disabled: "",
                              "prepend-icon": "mdi-account"
                            },
                            model: {
                              value: _vm.generalInformation.lastName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalInformation,
                                  "lastName",
                                  $$v
                                )
                              },
                              expression: "generalInformation.lastName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mr-2" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "########",
                                expression: "'########'"
                              }
                            ],
                            attrs: {
                              label: "Cédula de Identidad",
                              rules: [
                                _vm.rules.required(),
                                _vm.rules.specialCharacters()
                              ],
                              disabled: "",
                              "prepend-icon": "mdi-card-account-details"
                            },
                            model: {
                              value: _vm.generalInformation.idNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.generalInformation,
                                  "idNumber",
                                  $$v
                                )
                              },
                              expression: "generalInformation.idNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("phone-field", {
                            attrs: {
                              "phone-data":
                                _vm.generalInformation.telephoneNumber,
                              label: "Teléfono",
                              disabled: ""
                            },
                            on: {
                              "update:phoneData": function($event) {
                                return _vm.$set(
                                  _vm.generalInformation,
                                  "telephoneNumber",
                                  $event
                                )
                              },
                              "update:phone-data": function($event) {
                                return _vm.$set(
                                  _vm.generalInformation,
                                  "telephoneNumber",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { align: "end" } },
            [
              _c(
                "v-col",
                [
                  _c("v-textarea", {
                    attrs: {
                      counter: "65500",
                      outlined: "",
                      label: "Descripción del ticket",
                      hint: "Descripción sobre el ticket de asistencia remota",
                      rules: [
                        _vm.rules.fieldMaxLength(65500),
                        _vm.rules.specialCharacters([",", "."])
                      ]
                    },
                    model: {
                      value: _vm.generalInformation.description,
                      callback: function($$v) {
                        _vm.$set(_vm.generalInformation, "description", $$v)
                      },
                      expression: "generalInformation.description"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("FormNavigationButtons", {
        attrs: { "first-step": "true" },
        on: {
          validateStep: _vm.validateStep,
          reset: function($event) {
            return _vm.$router.push({ name: "tickets" })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }